module.exports = __webpack_public_path__ + "static/fonts/Pe-icon-7-stroke.74019bf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.ttf?-2irksn
// module id = RTRt
// module chunks = 1